var _title, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedincircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 40,
  width: 40,
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  focusable: "false"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Linkedin")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12",
  fill: "#187FB8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.748 9.463H8.96v7.01H6.748v-7.01zm8.257-.068c1.572 0 2.807 1.009 2.807 3.18v3.898h-2.508v-3.628c0-.95-.393-1.598-1.256-1.598-.66 0-1.027.438-1.198.86-.064.15-.054.362-.054.572v3.794h-2.485s.032-6.426 0-7.01h2.485v1.1c.147-.481.941-1.168 2.209-1.168zM7.813 6.154c.816 0 1.318.523 1.334 1.215 0 .679-.518 1.217-1.35 1.217h-.015c-.801 0-1.32-.536-1.32-1.215 0-.693.534-1.217 1.35-1.217z",
  fill: "#FFF"
})));
export default SvgLinkedincircle;